export default __webpack_public_path__ + "static/media/mayorista.134434fd.webp";